import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";
import { type Nullable } from "shared/types";

import type Category from "./Category";
import type Location from "./Location";

@Model()
class InstagramHandle extends ApplicationRecord {
  static jsonapiType = "instagram_handles";

  @Attr() biography: Nullable<string>;

  @Attr() businessCategoryName: Nullable<string>;

  @BelongsTo() category: Category;

  @Attr() categoryId: Nullable<number>;

  @Attr({ persist: false }) createdAt: string;

  @Attr() enabled: Nullable<boolean>;

  @Attr() followerCount: Nullable<number>;

  @Attr() fullName: Nullable<string>;

  @Attr() label: Nullable<string>;

  @BelongsTo() location: Location;

  @Attr() locationId: Nullable<number>;

  @Attr() mediaCount: Nullable<number>;

  @Attr() name: string;

  @Attr() notes: Nullable<string>;

  @Attr() profilePicUrl: Nullable<string>;

  @Attr({ persist: false }) updatedAt: string;

  @Attr({ persist: false }) url: string;

  @Attr() username: string;

  @Attr() verified: Nullable<boolean>;

  @Attr() website: Nullable<string>;
}

export default InstagramHandle;
